var exports = {
  "kL": "ChannelSourcePreview.module__container___Q0l6bE",
  "FS": "ChannelSourcePreview.module__textContainer___Q0l6bE",
  "S7": "ChannelSourcePreview.module__nameRow___Q0l6bE",
  "p": "ChannelSourcePreview.module__channelIcon___Q0l6bE",
  "oo": "ChannelSourcePreview.module__nameButton___Q0l6bE",
  "fh": "ChannelSourcePreview.module__nameText___Q0l6bE",
  "W$": "ChannelSourcePreview.module__subtext___Q0l6bE",
  "HR": "ChannelSourcePreview.module__subtextMuted___Q0l6bE",
  "G4": "ChannelSourcePreview.module__subtextPrimary___Q0l6bE",
  "XW": "ChannelSourcePreview.module__subtextBreadcrumb___Q0l6bE",
  "$T": "ChannelSourcePreview.module__subtextChevron___Q0l6bE",
  "my": "ChannelSourcePreview.module__avatar___Q0l6bE",
  "YQ": "ChannelSourcePreview.module__fallbackIcon___Q0l6bE",
  "bo": "ChannelSourcePreview.module__focusRingTight___Q0l6bE",
};

module.exports = exports;
